<div class="toaster-list" *ngIf="toasters$ | async as toasters">
  <toaster-item *ngFor="let toaster of toasters; trackBy: trackById" [toaster]="toaster"></toaster-item>
</div>
